
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import { TranslationActivity } from '@/domains/global/models'
import ConfirmModal from '@/domains/global/components/ConfirmModal.vue'
import JobActivityStatusPill from './JobActivityStatusPill.vue'
import JobActivityActions from './JobActivityActions.vue'

@Component({
  components: { JobActivityStatusPill, JobActivityActions }
})
export default class ActivityLine extends Vue {
  @Prop({ type: Object as () => TranslationActivity, required: true })
  readonly activity!: TranslationActivity

  @Prop({ type: Boolean, default: false })
  readonly documentsRemoved!: boolean

  @Prop({ type: String, default: 'draft' })
  readonly jobStatus!: string

  get removalModal() {
    return this.$refs.removalModal as ConfirmModal<TranslationActivity>
  }

  get activityName() {
    return this.activity.templateTypeName
  }

  get isPurged() {
    return !!this.activity.isDocumentPurged
  }

  get isCustomerReview() {
    return this.jobStatus === 'requires customer review'
  }

  get isJobCompleted() {
    return this.jobStatus === 'completed'
  }

  get isReviewCompleted() {
    return this.jobStatus === 'review completed'
  }

  get isPostReview() {
    return this.isCustomerReview || this.isReviewCompleted || this.isJobCompleted
  }

  get documentType() {
    switch (this.activity.documentType) {
      case 'customer-template':
        return 'Self-Service'
      case 'provider-template':
        return 'Standard'
      default:
        return null
    }
  }

  get isSelfService() {
    return this.activity.documentType === 'customer-template'
  }

  showRemoveModal() {
    this.removalModal.open(this.activity)
  }

  async confirmRemoval() {
    try {
      await axios.delete(`/api/v1/customer/jobs/${this.activity.jobId}/translation-activity/${this.activity.id}`)
      await this.$store.dispatch('success', 'Translation removed successfully')
      this.$emit('reload')
    } catch (err) {
      Sentry.captureException(err)
      await this.$store.dispatch('error', 'An error occurred removing the translation')
    }
  }
}
